import ColumnNode from "./ColumnNode";

/**
 * Registers the TipTap `column` node (no toolbar button).
 * Used together with TwoColumnsExtension.
 */
export default class ColumnExtension {
  constructor(options = {}) {
    this.options = options;
    this.nativeExtensionInstance = new ColumnNode(options);
  }

  get availableActions() {
    return [];
  }
}
